export default "/fonts/RV-Harmonia-Light.svg?f613505a22f2316b7fbde859f9b693d7";